import styles from "../../css/coursedetails.module.css";

function BootstrapOutline() {
  return (
    <>
      <p>
        <strong>This Course is also available in this program:</strong>
      </p>
      <ul className={styles.learnStruct}>
        <li>Frondend Development</li>
        <li>Web Development</li>
      </ul>
    </>
  );
}

export default BootstrapOutline;
